module.exports = __webpack_public_path__ + "img/transport-red.9bec2c03.svg";